import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home, NotFound } from './routes';
import { BrandNavbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { useWebsocket } from './hooks/useWebSocket';
import { Alert } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { LeagueData } from "./types/leagueData";

const API_URL = process.env.REACT_APP_API_URL;

function App() {
  const {errored, connected, message, send} = useWebsocket(`${API_URL}/leagues/ws`);  
  const [leagueID, setLeagueID] = useState<string>("");
  const [leagueState, setLeagueState] = useState<LeagueData | undefined>(undefined);

  useEffect(() => {
    if (!message) {
      return;
    }
    if (message.type === "update") {
      const data = message.data as LeagueData;
      setLeagueState(data)
    }
  }, [message, setLeagueState]);

  useEffect(() => {
    if (connected && leagueID) {
      send({
        type: "subscribe",
        data:{
          id: parseInt(leagueID)
        }
      })
    }
  }, [connected, errored, send, leagueID])
  
  return (
    <BrowserRouter>
      <BrandNavbar subscribe={setLeagueID}/>
      {!connected ? <Alert variant={"danger"}>Unable to connect to server</Alert> : <></>}
      <Routes>
        <Route index element={<Home leagueState={leagueState}/>}/>
        <Route path='*' element={<NotFound />}/>
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
